<template>
  <HvhModal title="Brand columns" :isLoading="isLoading || isLoadingSampleData" :value="true" persistent @input="$emit('close')">
    <v-form @input="formValid = $event" ref="form">
      <DropZone class="py-2" :item="draggingItem" @input="itemDropped" @hover="itemHover">
        <div class="drop-position" :class="{ selected: draggingItem && dropPosition === 0 }" />
        <template v-for="(item, ind) in columns">
          <div :key="item.column" ref="dropItems">
            <DragItem class="hvh-flex align-center mb-3" :disabled="!item.show" @drag-start="draggingItem = item" @drag-stop="draggingItem = null">
              <CallPlanningColumn class="grow-1" v-model="columns[ind]" @input="reorder" />
            </DragItem>
          </div>
          <div class="drop-position" :class="{ selected: draggingItem && dropPosition === ind + 1 }" :key="`span-${ind}`" />
        </template>
      </DropZone>
    </v-form>
    <template v-slot:actions>
      <v-btn flat class="hvh-btn hvh-btn--secondary" @click="$emit('close')">Cancel</v-btn>
      <v-btn flat class="hvh-btn hvh-btn--primary" :class="{ disabled: !formValid }" @click="$emit('input', columns)">Save</v-btn>
    </template>
  </HvhModal>
</template>

<script>
import axios from '../../axios';
import { errorDebug, tryParse } from '../../libraries/common';
import DragItem from '../common/drag/DragItem.vue';
import HvhModal from '../common/modal/HvhModal.vue';
import CallPlanningColumn from './CallPlanningColumn.vue';
export default {
  components: { CallPlanningColumn, HvhModal, DragItem },
  props: ['value', 'brandId', 'isLoading'],
  data() {
    return {
      columns: [],
      sampleData: null,
      isLoadingSampleData: false,
      draggingItem: null,
      dropPosition: null,
      formValid: null,
    };
  },
  computed: {
    allColumns() {
      return Object.keys((this.sampleData || [])
        .reduce((acc, f) => {
          Object.keys(f).forEach(key => acc[key] = true);
          return acc;
        }, {}));
    },
  },
  methods: {
    reorder() {
      this.columns = [
        ...this.columns.filter(f => f.show),
        ...this.columns.filter(f => !f.show).sortBy(f => f.ind),
      ];
    },
    splitCases(prop) {
      if (prop.camelCase() === prop) {
        return prop.splitByUpperCase().map(f => f.toUpperCase()).join(' ');
      } else {
        return prop.split('_').map(f => f.toUpperCase()).join(' ');
      }
    },
    getPosition(event) {
      var dropItems = (this.$refs.dropItems || []).map(el => el.getBoundingClientRect());
      var position = Math.min(dropItems.filter(f => f.y < event.clientY).length, this.columns.sum(f => f.show ? 1 : 0));
      return position;
    },
    itemHover(item, event) {
      this.dropPosition = item && this.getPosition(event);
    },
    itemDropped(item, event) {
      setTimeout(() => {
        this.dropPosition = null;
        var position = this.getPosition(event);
        var currentIndex = this.columns.indexOf(item);
        this.columns = [...this.columns].remove(item).pushAt(position > currentIndex ? position - 1 : position, item);
      }, 100);
    },
    unselectItem(item) {
      this.pickedColumns = this.pickedColumns.filter((f) => f.name !== item.name);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisCallPlanningChooseColumns'] = this;

    this.isLoadingSampleData = true;
    axios.get(`/api/CallPlanning/${this.brandId}/Admin/GetSampleData`)
      .then(({ data }) => {
        this.sampleData = data
          .map(f => ({
            ...f,
            ...tryParse(f.additionalData),
          }))
          .map(({ additionalData, ...restOfProps }) => restOfProps); // eslint-disable-line

        var valueColumns = (this.value || [])
          .reduce((acc, f) => { acc[f.column] = f; return acc; }, {});

        this.columns = this.allColumns
          .filter(f => f !== 'id')
          .map((column, ind) => ({
            column,
            text: valueColumns[column]?.text || this.splitCases(column),
            originalText: this.splitCases(column),
            show: valueColumns[column]?.show,
            ind,
          }));
        this.reorder();
      })
      .catch(errorDebug)
      .then(() => this.isLoadingSampleData = false);
  }
}
</script>

<style lang="scss" scoped>
.drop-position {
  height: 5px;
  &.selected {
    background-color: lightgray;
  }
}
</style>